export default "__VITE_ASSET__BTVkWKdf__ 480w, __VITE_ASSET__BH6cno2O__ 768w, __VITE_ASSET__bFf5MJC1__ 780w";